import {
  IconAirplane, IconCar, IconCruiseShip, IconHome, IconHotel, IconTravelBag,
} from '@americanexpress/dls-icons';
import React from 'react';

export const FLIGHTS = 'flights';
export const HOTELS = 'hotels';
export const VACATION_RENTALS = 'vacation-rentals';
export const PACKAGES = 'packages';
export const CARS = 'cars';
export const CRUISES = 'cruises';

export const INTL_PATH_PACKAGES = 'packages';
export const US_PATH_PACKAGES = 'vacation-packages';
export const ABANDON_HOTEL_CATEGORY = 'Hotel Abandon';
export const TAB_TO_ICON = {
  [FLIGHTS]: <IconAirplane />,
  [HOTELS]: <IconHotel />,
  [VACATION_RENTALS]: <IconHome />,
  [PACKAGES]: <IconTravelBag />,
  [CARS]: <IconCar />,
  [CRUISES]: <IconCruiseShip />,
};
